import { startTask, reTry, resetTimes, getFileHash } from "./uploadTools"
import { signChunk, uploadData, completeFromQing } from "./uploadRequest"
import { message } from "antd"
import SparkMD5 from "spark-md5"

let global_options = {}, uploadId = "", totalFile = null, totalMd5 = "", md5Array = []

/*
 * 向青云确认上传完成
 */
export let confirmQingUpload = function (upload_id, chunkCount, onProgress) {
  const chunk_order = Array.from({length: chunkCount},
    (chunk, index) => ({ // 片序号
      "part_number": index
    })
  )

  const signParams = {
    ...global_options,
    query: "?upload_id=" + upload_id,
    method: "post",
    contentType: "application/json"
  }
  getFileHash(totalFile).then(result => {
    signParams.contentMd5 = result
    return result === totalMd5 ? signChunk(signParams) : Promise.reject({code: 'bad_digest'})
  })
  .then(sign =>
    completeFromQing(sign, signParams.filename, signParams.contentMd5, upload_id, chunk_order) // complete
  ).then(result => {// 青云检验完成
    resetTimes()
    onProgress({
      isNormal: true,
      value: 99
    })
  }, error => { // 青云校验失败
    if (error.code === 'bad_digest') {
      onProgress({
        isNormal: false,
        value: 'bad_digest'
      })
    } else {
      reTry(() =>
          confirmQingUpload(upload_id, chunkCount, onProgress),
        error && error.message
      )
        .then(null, () => {
          onProgress({
            isNormal: false,
            value: "exception"
          })
        })
    }
  })
}

/**
 * 分片循环, 片、索引、回调
 */
export let uploadChunk = function (chunk, index, onFinish, onProgress) {
  const currentMd5 = SparkMD5.ArrayBuffer.hash(chunk)
  const uploadQuery = global_options.query.replace(/@/, index)
  const signParams = {...global_options, query: uploadQuery, contentMd5: currentMd5} // 单片签名时注入单片的 md5
  let sign = {}; // 避免语法分析错误

  (new Promise((resolve, reject) => {
    if (currentMd5 !== md5Array[index]) {
      reject({code: 'bad_digest'})
    } else {
      resolve()
    }
  })).then(() => signChunk(signParams))
    .then(result => { // 单片签名
      sign = result
      const uploadParams = {
        sign,
        chunk,
        MD5: currentMd5,
        query: uploadQuery,
        fileName: global_options.filename
      }
      return uploadData(uploadParams, onProgress)
    })
    .then((res) => {
      resetTimes()
      onFinish() // start next chunk
    })
    .catch(err => {
      if (err.code === 'bad_digest') { // 单片签名出错，则 disableFile
        onProgress({
          isNormal: false,
          value: 'bad_digest'
        })
      } else {
        reTry(() => uploadChunk(chunk, index, onFinish, onProgress), err && err.message)
          .then(null, () => { // 重试多次无效，则 disableTask
            onProgress({
              isNormal: false,
              value: 'exception'
            })
          })
      }
    })
}

export default function (file, sign, qingRes, onProgress) { // settings 为青云返回的总数据的信息
  global_options = {
    filename: sign.filename,
    contentType: "application/octet-stream",
    method: "put",
    query: `?part_number=@&upload_id=${qingRes.upload_id}`
  }
  uploadId = qingRes.upload_id
  qingRes.name = file.name
  totalFile = file
  totalMd5 = sign.contentMd5
  md5Array = sign.md5Array
  startTask(file, 0, onProgress)
    .then(chunkCount => {
      confirmQingUpload(uploadId, chunkCount, onProgress)
    })
  .catch(err => message.error("文件读取出错，请重试！"))
}



// WEBPACK FOOTER //
// ./src/app/components/normal/BasicModal/UploadModal/tools/uploadChunks.js